import { useQuery } from "@tanstack/react-query";
import { useLocation, useParams } from "react-router";
import { trpc } from "../../app/trpc.js";

/**
 * Салон, в котором открыт кабинет: пояс, роль вошедшего, привязка к мастеру и базовый путь.
 * Страницы кабинета открываются и у владельца (`/s/:salonId`), и у админа (`/admin/s/:salonId`):
 * ссылки внутри кабинета строим от `base`.
 */
export function useCabinet() {
  const { salonId = "" } = useParams();
  const { pathname } = useLocation();
  const q = useQuery(trpc.cabinet.context.queryOptions({ salonId }, { staleTime: 5 * 60_000, enabled: Boolean(salonId) }));
  const base = pathname.startsWith("/admin/") ? `/admin/s/${salonId}` : `/s/${salonId}`;
  return {
    salonId,
    base,
    loading: q.isPending,
    error: q.isError,
    salonName: q.data?.salon.name ?? "",
    timezone: q.data?.salon.timezone ?? "Europe/Belgrade",
    isOwner: q.data?.role === "owner",
    /** Мастер, к которому привязан вошедший (у владельца-мастера тоже есть). */
    masterId: q.data?.masterId ?? null,
  };
}

/** Путь внутри кабинета, если уведомление пришло с адресом владельца (`/s/:id/...`), а открыт кабинет админа. */
export function cabinetPath(base: string, url: string): string {
  const m = /^\/s\/[^/]+(\/.*)?$/.exec(url);
  return m ? `${base}${m[1] ?? ""}` : url;
}
